import { faBars, faCheckSquare, faChevronDown, faChevronRight, faCloud, faFile, faFolder, faFolderOpen, faMinusSquare, faPlusSquare, faRouter, faSquare, faWarehouse } from "@fortawesome/pro-solid-svg-icons";
import { faCheckSquare as faCheckSquareRegular } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useCallback, useEffect, useState } from "react";
import CheckboxTree from "react-checkbox-tree";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import { siteMap } from "../../api/site";
import Loader from "../common/Loader";

const SiteTreeSingleSelect = ({ onClick, initialChecked, expandToLevel, siteMapLevel, inline }) => {
	const [nodes, setNodes] = useState([]);
	const [expanded, setExpanded] = useState([]);
	const [checked, setChecked] = useState([]);
	const [loading, setLoading] = useState(true);

	const setExpandedCallback = useCallback(
		(data) => {
			const getNodeIds = (nodes) => {
				let ids = [];

				nodes.forEach(({ value, nodeLevel, children }) => {
					if (nodeLevel <= expandToLevel) {
						ids = [...ids, value, ...getNodeIds(children)];
					}
				});

				return ids;
			};

			var ids = getNodeIds(data);

			setExpanded(ids);
		},
		[expandToLevel],
	);

	useEffect(() => {
		let isSubscribed = true;

		function findAndExpand(find, node, previous) {
			node.forEach((child) => {
				if (child.value && child.value === find) {
					setExpanded(`${previous},${child.value}`.split(","));
					return;
				}

				findAndExpand(find, child.children, `${child.value},${previous}`);
			});
		}

		async function loadSiteMap() {
			var data = await siteMap(siteMapLevel, false, false);

			if (isSubscribed) {
				fixIcons(data);

				setNodes(data);

				setExpandedCallback(data);

				if (initialChecked) {
					setChecked(initialChecked.split(","));
					findAndExpand(initialChecked, data, "");
				}

				setLoading(false);

				var reactTree = document.getElementsByClassName("react-checkbox-tree")[0];
				if (reactTree) {
					reactTree.scrollTo(0, 0);
				}
			}
		}

		function fixIcons(data) {
			data.forEach(function(node) {
				switch (node.nodeLevel) {
					case 0:
					case "Site":
						node.icon = <FontAwesomeIcon className="rct-icon rct-icon-leaf-close gradient-icons" size="lg" icon={faCloud} fixedWidth />;
						break;
					case 1:
					case "Building":
						node.icon = <FontAwesomeIcon className="rct-icon rct-icon-leaf-close gradient-icons" size="lg" icon={faWarehouse} fixedWidth />;
						break;
					case 2:
					case "Zone":
						node.icon = <FontAwesomeIcon className="rct-icon rct-icon-leaf-close gradient-icons" size="lg" icon={faBars} fixedWidth />;
						break;
					case 3:
					case "Group":
						node.icon = <FontAwesomeIcon className="rct-icon rct-icon-leaf-close gradient-icons" size="lg" icon={faRouter} fixedWidth />;
						break;
					default:
						node.icon = "";
						break;
				}

				fixIcons(node.children);
			});
		}

		loadSiteMap();

		return () => (isSubscribed = false);
	}, [initialChecked, setExpandedCallback, siteMapLevel, expandToLevel]);

	const click = (e) => {
		if (e.isLeaf) {
			setChecked([e.value]);
		}
		if (onClick) {
			if (e.isLeaf) {
				onClick(e.value, e.label, e.parent.label);
			}
		}
	};

	const checkedChanged = (newChecked) => {
		//Stop unselecting of current item
		if (newChecked.length === 0) {
			return;
		}

		//Switch to new selected item
		if (newChecked.length > 1) {
			newChecked = newChecked.filter((x) => !checked.includes(x));
		}

		if (onClick) {
			onClick(newChecked[0]);
		}

		setChecked(newChecked);
	};

	return (
		<>
			{loading ? (
				<div className={inline ? "" : "card"}>
					<Loader />
				</div>
			) : (
				<div className={`p-2 ${inline ? "" : "card mt-2"}`}>
					<CheckboxTree
						nodes={nodes}
						checked={checked}
						expanded={expanded}
						onCheck={(checked) => checkedChanged(checked)}
						onExpand={(expanded) => setExpanded(expanded)}
						showNodeIcon={true}
						showExpandAll={false}
						optimisticToggle={true}
						expandOnClick={true}
						onlyLeafCheckboxes={onClick}
						onClick={click}
						icons={{
							check: <FontAwesomeIcon className="rct-icon rct-icon-check" icon={faCheckSquare} size="lg" fixedWidth />,
							uncheck: <FontAwesomeIcon className="rct-icon rct-icon-uncheck" icon={faSquare} size="lg" fixedWidth />,
							halfCheck: <FontAwesomeIcon className="rct-icon rct-icon-half-check" icon={faCheckSquareRegular} size="lg" fixedWidth />,
							expandClose: <FontAwesomeIcon className="rct-icon rct-icon-expand-close" icon={faChevronRight} size="lg" fixedWidth />,
							expandOpen: <FontAwesomeIcon className="rct-icon rct-icon-expand-open" icon={faChevronDown} size="lg" fixedWidth />,
							expandAll: <FontAwesomeIcon className="rct-icon rct-icon-expand-all" icon={faPlusSquare} size="lg" fixedWidth />,
							collapseAll: <FontAwesomeIcon className="rct-icon rct-icon-collapse-all" icon={faMinusSquare} size="lg" fixedWidth />,
							parentClose: <FontAwesomeIcon className="rct-icon rct-icon-parent-close" icon={faFolder} size="lg" fixedWidth />,
							parentOpen: <FontAwesomeIcon className="rct-icon rct-icon-parent-open" icon={faFolderOpen} size="lg" fixedWidth />,
							leaf: <FontAwesomeIcon className="rct-icon rct-icon-leaf-close" icon={faFile} size="lg" fixedWidth />,
						}}
					/>
				</div>
			)}
		</>
	);
};

export default SiteTreeSingleSelect;
